<!-- 滿意度圖表分析，畫面渲染元件 -->
<template>
  <div class="satisfaction-analysis-chat-container">
    <div :id="`chart-container`" class="chart-container"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'SatisfactionAnalysisBarChartComponent',
  components: {},
  props: {
    satisfactionAnalysis: {
      type: Object,
      default: () => ({}),
    },
  },
  async activated() {},
  data() {
    return {}
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.chatInit()
    }, 200)
  },
  methods: {
    chatInit() {
      if (!this.satisfactionAnalysis) return
      if (this.satisfactionAnalysis.topicDescription.length > 0) {
        this.satisfactionAnalysis.topicDescription.reverse()
      }

      if (this.satisfactionAnalysis.satisfactionAnalysis.length > 0) {
        this.satisfactionAnalysis.satisfactionAnalysis.reverse()
      }
      let vm = this
      var dom = document.getElementById('chart-container')
      var myChart = echarts.init(dom, null, {
        renderer: 'canvas',
        useDirtyRect: false,
      })
      var app = {}

      var option

      option = {
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: 'category',
          // data: ["Brazil", "Indonesia", "USA", "India", "China", "World"],
          data: vm.satisfactionAnalysis.topicDescription,
        },
        series: [
          {
            name: '滿意度指標分析',
            type: 'bar',
            label: {
              show: false,
              position: 'inside',
              formatter: '{c}',
              textStyle: {
                color: 'red',
                fontWeight: 'bold',
                fontSize: '17px',
              },
            },
            // data: [19325, 23438, 31000, 121594, 134141, 681807],
            data: vm.satisfactionAnalysis.satisfactionAnalysis,
            itemStyle: {
              color: function (params) {
                if (params.data <= 3) {
                  return '#E16D6D'
                } else if (params.data <= 4) {
                  return '#F9DE5D'
                } else {
                  return '#9eca7f'
                }
              },
            },
          },
        ],
      }

      if (option && typeof option === 'object') {
        myChart.setOption(option)
      }

      window.addEventListener('resize', myChart.resize)
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-container {
  position: relative;
  height: 50vh;
  overflow: hidden;
}
</style>
>
